// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1ocPH","emails":"CreateEditClinics_emails__KIrTm","emailTagLabel":"CreateEditClinics_emailTagLabel__3clq0"};